import { OrderHistory } from "./orderHistory";
import { Article } from "./article";
import { Customer } from "./customer";
import { OrderStatus } from "./orderStatus";
import { OrderType } from "./orderType";
import { Supplier } from "./supplier";
import { ClientType } from "../enums/clientTypeEnum";
import { CarBrand, defaultCarBrand } from "./carBrand";

export const getDefaultOrder = (clientType: ClientType): Order => ({
  ...defaultOrder,
  clientType,
  approved: clientType === ClientType.Standard || clientType === ClientType.Fleet ? false : true,  
});

export interface Order {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  deletedAt: string | null;
  registrationNumber: string;
  vin: string;
  aoNumber: string;
  carInfo: string;
  purchaseOrderNumber: string;
  salesOrderNumber: string;
  comment: string;
  internalComment: string;
  assignedTo: string;
  orderedBy: string;
  followUp: string;
  emailBody: string;
  warehouseLocation: string;
  userName: string;
  userEmail: string;
  userId: string;
  filename: string;
  filepath: string;
  carModel: string | null;
  carBrand: string | null;
  kTypeNumber: string | null;
  engineCode: string | null;
  exported: boolean;
  imported: boolean;
  exportedAt: string | null;
  importedAt: string | null;
  vinVerified: boolean | null;
  correctedVin: boolean | null;
  approved: boolean | null;
  denied: boolean | null;
  arriveDate: string | null;
  bookingDate: string | null;
  deliveryDate: string | null;
  pickupDate: string | null;
  printDate: string | null;
  orderDate: string | null;
  articles: Article[] | null;
  supplierId: string | null;
  supplier: Supplier | null;
  customer: Customer | null;
  customerId: string | null;
  orderType: OrderType | null;
  orderTypeId: string | null;
  orderStatus: OrderStatus | null;
  orderStatusId: string | null;
  orderHistory: OrderHistory[] | null;
  discount: number | null;
  carUrl: string | null;
  clientType: ClientType | ClientType.Standard;
  externalOrderId: number | null;
  selectedCarBrandId?: string | null;
  selectedCarBrand: CarBrand | null;
  odometer: number | null;
  clientVehicleRetriever: string | null;
  clientExternalOrderId: string | null;
  storeId: string | null;
  workshopId: string | null;
  workshopName: string | null;
  overrideException?: boolean | null;
  priceProposalMessage?: string | null;
}

export const defaultOrder: Order = {
  id: "",
  createdAt: "",
  updatedAt: null,
  deletedAt: null,
  registrationNumber: "",
  vin: "",
  aoNumber: "",
  carInfo: "",
  purchaseOrderNumber: "",
  salesOrderNumber: "",
  comment: "",
  internalComment: "",
  filename: "",
  filepath: "",
  assignedTo: "",
  orderedBy: "",
  followUp: "",
  emailBody: "",
  warehouseLocation: "",
  userName: "",
  userEmail: "",
  userId: "",
  carModel: "",
  carBrand: "",
  kTypeNumber: "",
  engineCode: "",
  vinVerified: false,
  correctedVin: false,
  approved: false,
  denied: false,
  exported: false,
  arriveDate: null,
  bookingDate: null,
  deliveryDate: null,
  pickupDate: null,
  printDate: null,
  orderDate: null,
  articles: null,
  supplierId: null,
  supplier: null,
  customer: null,
  customerId: null,
  orderTypeId: null,
  orderType: null,
  orderStatus: null,
  orderStatusId: null,
  orderHistory: null,
  discount: null,
  carUrl: null,
  clientType: ClientType.Standard,
  externalOrderId: null,
  selectedCarBrandId: null,
  selectedCarBrand: defaultCarBrand,
  odometer: null,
  clientVehicleRetriever: null,
  clientExternalOrderId: null,
  storeId: null,
  workshopId: null,
  workshopName: null,
  overrideException: null,
  priceProposalMessage: null,
  imported: false,
  exportedAt: null,
  importedAt: null,
}